import React, { useState } from 'react';
import { Search, Filter, Eye, ArrowLeft, ArrowRight } from 'lucide-react';
import { mockData } from '../mock';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Motorcycle PPF work - Two wheels move the soul
  const bikePPFImages = [
    {
      id: 'bike1',
      title: "Motorcycle Tank PPF Installation",
      category: "bike-ppf",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/mxc33csg_30255ec5-6c3b-48d1-827e-3ec1213cba8c.jpeg",
      description: "Precision PPF application on motorcycle fuel tank for maximum protection"
    },
    {
      id: 'bike2',
      title: "BMW Motorcycle PPF Work",
      category: "bike-ppf",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/9akx7ylb_7999321b-4ac6-4119-a37e-09c2639c0e11.jpeg",
      description: "Expert PPF installation on BMW motorcycle fairings and body panels"
    },
    {
      id: 'bike3',
      title: "Harley-Davidson PPF Protection",
      category: "bike-ppf",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/epjewf53_5f298ba1-1340-4daa-8ba6-57e159e78c47.jpeg",
      description: "Professional PPF application on Harley-Davidson motorcycle in our facility"
    },
    {
      id: 'bike4',
      title: "Premium Motorcycle Detailing",
      category: "bike-ppf",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/xieldkk3_91764a3f-d66b-4ef9-962a-d6ea09702f4b.jpeg",
      description: "Meticulous PPF installation on motorcycle tank with precision techniques"
    }
  ];

  // Real photos from Unisol Global's professional detailing work
  const featuredDetailingImages = [
    {
      id: 'real1',
      title: "Vehicle prep and decontamination",
      category: "featured",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/bffomspn_a36e005d-c39e-4120-90c0-c246506870ff.jpeg",
      description: "Professional vehicle preparation and decontamination process in our state-of-the-art facility"
    },
    {
      id: 'real2',
      title: "Precision PPF Application",
      category: "featured",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/azj018bu_11f77834-7a8c-4ffd-b19c-ab95793475f6.jpeg",
      description: "Expert technician applying paint protection film with precision and care"
    },
    {
      id: 'real3',
      title: "Window Film Installation",
      category: "featured",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/b5536lt9_5bd70513-6d73-461c-b5ff-b3bed641c949.jpeg",
      description: "Professional window tinting and protection film application"
    },
    {
      id: 'real4',
      title: "Professional Vehicle Polishing",
      category: "featured",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/9o90hvw2_4bd76443-bc04-4f7f-be91-e75aa80dc936.jpeg",
      description: "Expert polishing and paint correction on Toyota Prado in our facility"
    },
    {
      id: 'real5',
      title: "Premium Interior Pre - Cut PPF",
      category: "featured",
      image: "https://customer-assets.emergentagent.com/job_premium-detailing-3/artifacts/h7mrwxs7_756e9947-a436-4558-8092-a657ae709a41.jpeg",
      description: "Precision pre-cut PPF application on luxury vehicle interior surfaces and trim"
    }
  ];

  // Professional stock images from our curated collection
  const stockImages = [
    {
      id: 1,
      title: "Luxury Porsche Detailing",
      category: "services",
      image: "https://images.unsplash.com/photo-1665519448106-e6ab874553aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w2ODU4NDd8MHwxfHNlYXJjaHwxfHxjYXIlMjBkZXRhaWxpbmd8ZW58MHx8fHwxNzU4MjE5MTQ2fDA&ixlib=rb-4.1.0&q=85",
      description: "Premium paint protection and detailing service on luxury Porsche"
    },
    {
      id: 2,
      title: "BMW M3 Professional Care",
      category: "services", 
      image: "https://images.unsplash.com/photo-1622691972122-03104c7e0a03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w2ODU4NDd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhdXRvbW90aXZlfGVufDB8fHx8MTc1ODIxOTE5M3ww&ixlib=rb-4.1.0&q=85",
      description: "Complete protection package for BMW M3 with premium coating"
    },
    {
      id: 3,
      title: "Professional Workshop Training",
      category: "training",
      image: "https://images.unsplash.com/photo-1740914994068-cf0325e0ed36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NTgyMTkxOTN8MA&ixlib=rb-4.1.0&q=85",
      description: "Professional training facility with state-of-the-art equipment"
    },
    {
      id: 4,
      title: "Precision Engine Work",
      category: "training",
      image: "https://images.unsplash.com/photo-1672844825476-66737d85bfce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxhdXRvbW90aXZlJTIwd29ya3Nob3B8ZW58MHx8fHwxNzU4MjE5MTgxfDA&ixlib=rb-4.1.0&q=85",
      description: "Detailed automotive engine maintenance training session"
    },
    {
      id: 5,
      title: "Luxury Vehicle Service",
      category: "services",
      image: "https://images.unsplash.com/photo-1647923320920-9c9da74f7419?crop=entropy&cs=srgb&fm=jpg&ixid=M3w2ODU4NDd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhdXRvbW90aXZlfGVufDB8fHx8MTc1ODIxOTE5M3ww&ixlib=rb-4.1.0&q=85",
      description: "Premium automotive service for luxury vehicles"
    },
    {
      id: 6,
      title: "Lamborghini Huracan PPF",
      category: "services",
      image: "https://images.unsplash.com/photo-1544819667-3131b8c3d8f6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      description: "Specialized PPF installation on Lamborghini Huracan"
    },
    {
      id: 7,
      title: "Business Training Session",
      category: "training",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      description: "Entrepreneurship training for aspiring detailing business owners"
    },
    {
      id: 8,
      title: "Porsche 911 Graphene Coating",
      category: "services",
      image: "https://images.unsplash.com/photo-1544829099-b9a0c5303bea?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      description: "Advanced graphene coating application on Porsche 911"
    },
    {
      id: 9,
      title: "Rupes Training Program",
      category: "training",
      image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      description: "Official Rupes polishing system training in progress"
    }
  ];

  // Combine all image arrays
  const galleryImages = [...featuredDetailingImages, ...bikePPFImages, ...stockImages];

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'featured', name: 'Detailing at its best!' },
    { id: 'bike-ppf', name: 'Two wheels move the soul - Bike PPF' },
    { id: 'services', name: 'Service Work' },
    { id: 'training', name: 'Training Sessions' }
  ];

  const filteredImages = galleryImages.filter(image => {
    const matchesCategory = selectedCategory === 'all' || image.category === selectedCategory;
    const matchesSearch = image.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         image.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const openImageModal = (image) => {
    setSelectedImage(image);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    if (!selectedImage) return;
    
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = currentIndex === filteredImages.length - 1 ? 0 : currentIndex + 1;
    } else {
      newIndex = currentIndex === 0 ? filteredImages.length - 1 : currentIndex - 1;
    }
    
    setSelectedImage(filteredImages[newIndex]);
  };

  return (
    <div className="min-h-screen pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h1 className="text-5xl md:text-6xl font-bold text-white">
              Our
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500"> Gallery</span>
            </h1>
            <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
              Showcase of our Premium Automotive Detailing work and Professional sessions
            </p>
          </div>
        </div>
      </section>

      {/* Filter and Search */}
      <section className="py-12 bg-slate-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-6 items-center justify-between">
            {/* Category Filters */}
            <div className="flex flex-wrap gap-3">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
                    selectedCategory === category.id
                      ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-slate-900'
                      : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
                  }`}
                >
                  <Filter className="inline-block mr-2" size={16} />
                  {category.name}
                </button>
              ))}
            </div>

            {/* Search */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
              <input
                type="text"
                placeholder="Search gallery..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-3 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-amber-500 focus:outline-none w-64"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Section - Detailing at its best! */}
      {(selectedCategory === 'all' || selectedCategory === 'featured') && !searchTerm && (
        <section className="py-20 bg-gradient-to-r from-amber-50 to-orange-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center space-y-6 mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-orange-600">
                  Detailing at its best!
                </span>
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto">
                Witness the precision, expertise, and dedication that goes into every vehicle at Unisol Global. 
                These exclusive photos showcase our team's craftsmanship and state-of-the-art facility.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {featuredDetailingImages.map((image, index) => (
                <div
                  key={image.id}
                  className={`group relative bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl hover:transform hover:-translate-y-3 transition-all duration-500 cursor-pointer ${
                    index === 0 ? 'md:col-span-2 lg:col-span-1' : ''
                  }`}
                  onClick={() => openImageModal(image)}
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={image.image}
                      alt={image.title}
                      className="w-full object-contain bg-gray-100 group-hover:scale-105 transition-transform duration-700"
                      style={{ minHeight: '200px', maxHeight: '400px' }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <div className="absolute top-4 left-4">
                      <span className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                        EXCLUSIVE
                      </span>
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="w-20 h-20 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full flex items-center justify-center shadow-xl">
                        <Eye className="text-white" size={32} />
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-6 space-y-4">
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-amber-600 transition-colors">
                      {image.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {image.description}
                    </p>
                    <div className="flex items-center space-x-2 text-amber-600">
                      <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                      <span className="text-sm font-semibold">Real Work by Unisol Global</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Bike PPF Section - Two wheels move the soul */}
      {(selectedCategory === 'all' || selectedCategory === 'bike-ppf') && !searchTerm && (
        <section className="py-20 bg-gradient-to-r from-blue-50 to-indigo-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center space-y-6 mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  Two wheels move the soul - Bike PPF
                </span>
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto">
                Protecting the passion of motorcycle enthusiasts with precision PPF application. 
                From sportbikes to cruisers, we understand what makes your ride special.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6">
              {bikePPFImages.map((image, index) => (
                <div
                  key={image.id}
                  className="group relative bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl hover:transform hover:-translate-y-3 transition-all duration-500 cursor-pointer"
                  onClick={() => openImageModal(image)}
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={image.image}
                      alt={image.title}
                      className="w-full object-contain bg-gray-100 group-hover:scale-105 transition-transform duration-700"
                      style={{ minHeight: '200px', maxHeight: '300px' }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <div className="absolute top-4 left-4">
                      <span className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                        BIKE PPF
                      </span>
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full flex items-center justify-center shadow-xl">
                        <Eye className="text-white" size={32} />
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-6 space-y-4">
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                      {image.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {image.description}
                    </p>
                    <div className="flex items-center space-x-2 text-blue-600">
                      <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                      <span className="text-sm font-semibold">Motorcycle PPF Specialists</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Gallery Grid */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="group relative bg-slate-800 rounded-xl overflow-hidden hover:transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
                onClick={() => openImageModal(image)}
              >
                <div className="relative overflow-hidden bg-gray-100">
                  <img
                    src={image.image}
                    alt={image.title}
                    className="w-full object-contain group-hover:scale-105 transition-transform duration-500"
                    style={{ minHeight: '200px', maxHeight: '300px' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center">
                      <Eye className="text-slate-900" size={28} />
                    </div>
                  </div>
                </div>
                
                <div className="p-6 space-y-3">
                  <div className="flex items-center justify-between">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      image.category === 'services' 
                        ? 'bg-blue-500/20 text-blue-400' 
                        : image.category === 'featured'
                        ? 'bg-amber-500/20 text-amber-400'
                        : image.category === 'bike-ppf'
                        ? 'bg-indigo-500/20 text-indigo-400'
                        : 'bg-green-500/20 text-green-400'
                    }`}>
                      {image.category === 'services' ? 'Service Work' : 
                       image.category === 'featured' ? 'Detailing at its best!' : 
                       image.category === 'bike-ppf' ? 'Two wheels move the soul' : 'Training'}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-white group-hover:text-amber-400 transition-colors">
                    {image.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    {image.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* No Results */}
          {filteredImages.length === 0 && (
            <div className="text-center py-20">
              <div className="text-slate-400 text-xl mb-4">No images found</div>
              <p className="text-slate-500">Try adjusting your search terms or filters</p>
            </div>
          )}
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="relative max-w-5xl w-full">
            {/* Navigation Arrows */}
            <button
              onClick={() => navigateImage('prev')}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-slate-800/80 rounded-full flex items-center justify-center hover:bg-slate-700 transition-colors z-10"
            >
              <ArrowLeft className="text-white" size={24} />
            </button>
            
            <button
              onClick={() => navigateImage('next')}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-slate-800/80 rounded-full flex items-center justify-center hover:bg-slate-700 transition-colors z-10"
            >
              <ArrowRight className="text-white" size={24} />
            </button>

            {/* Close Button */}
            <button
              onClick={closeImageModal}
              className="absolute top-4 right-4 w-12 h-12 bg-slate-800/80 rounded-full flex items-center justify-center hover:bg-slate-700 transition-colors z-10"
            >
              <span className="text-white text-2xl">×</span>
            </button>

            {/* Image and Details */}
            <div className="bg-slate-900 rounded-2xl overflow-hidden">
              <div className="relative">
                <img
                  src={selectedImage.image}
                  alt={selectedImage.title}
                  className="w-full object-contain bg-gray-100"
                  style={{ maxHeight: '70vh', minHeight: '300px' }}
                />
              </div>
              
              <div className="p-8">
                <div className="flex items-center justify-between mb-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    selectedImage.category === 'services' 
                      ? 'bg-blue-500/20 text-blue-400' 
                      : selectedImage.category === 'featured'
                      ? 'bg-amber-500/20 text-amber-400'
                      : selectedImage.category === 'bike-ppf'
                      ? 'bg-indigo-500/20 text-indigo-400'
                      : 'bg-green-500/20 text-green-400'
                  }`}>
                    {selectedImage.category === 'services' ? 'Service Work' : 
                     selectedImage.category === 'featured' ? 'Detailing at its best!' : 
                     selectedImage.category === 'bike-ppf' ? 'Two wheels move the soul' : 'Training'}
                  </span>
                </div>
                <h2 className="text-3xl font-bold text-white mb-4">{selectedImage.title}</h2>
                <p className="text-slate-300 text-lg leading-relaxed">{selectedImage.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;